module.exports = __webpack_public_path__ + "img/logo.d5d20e1d.png";